class Collapsible {
  constructor(el) {
    this.el = el
    this.initialize()
  }

  initialize() {
    this.bindUI()
    this.bindEvents()
  }

  bindUI() {
    this.ui = {}
    this.ui.$collapsibles = this.el.querySelectorAll('.js-nav-item .title-wrapper')
    this.ui.$menu = document.querySelector('.js-navigation')
    this.isOpen = false
  }
  
  bindEvents() {
    for (let i = 0; i < this.ui.$collapsibles.length; i++) {
      this.ui.$collapsibles[i].addEventListener('click', this.toggle.bind(this))
    }
  }

  toggle(e) {
    e.stopPropagation()
    let target = e.target.closest('.js-nav-item')
    if(!target.matches('.js-nav-item')) return

    for (let i = 0; i < this.ui.$collapsibles.length; i++) {
      this.close(this.ui.$collapsibles[i])
    }
    this.isOpen = target.classList.contains('is-active') 
    if(!this.isOpen) {
      this.open(target)
    } else {
      this.close(target)
    }    
    window.menu[0].trapFocus(document.querySelector('.js-header'))
  }

  open(target) {
    target.classList.add('is-active')
    let content = target.closest('.js-nav-item').querySelector('.js-submenu')    
    target.querySelector('.title-wrapper').setAttribute('aria-expanded','true')
    content.setAttribute('aria-expanded','true')
    content.style.maxHeight = `${content.scrollHeight}px`
    content.querySelectorAll('a').forEach(elt => {
      elt.setAttribute('tabindex','0')
    });
    this.isOpen = true
  }

  close(target) {    
    this.isOpen = false
    target.classList.remove('is-active')
    let content = target.closest('.js-nav-item').querySelector('.js-submenu')
    target.setAttribute('aria-expanded','false')
    content.setAttribute('aria-expanded','false')
    content.querySelectorAll('a').forEach(elt => {
      elt.setAttribute('tabindex','-1')
    });
    content.style.maxHeight = null
  }
}

export default Collapsible
